// extracted by mini-css-extract-plugin
module.exports = {"heading":"SkcNA t4d57","blogLinks":"_25eEY"};